import { Controller, useFormContext } from 'react-hook-form';
import { Input, Label, FormGroup } from '@polichat/flamboyant';
import { SUPPORT_OPTIONS } from '../useFinishChatForm';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';
import { useMemo } from 'react';
import styles from '../styles.module.css';

export function SupportForm() {
  const { control } = useFormContext();

  // Traduções para opções de suporte
  const questionText = useGlotaT('spa.chat.finishChat.support.question.label');
  const complaintText = useGlotaT(
    'spa.chat.finishChat.support.complaint.label'
  );
  const suggestionText = useGlotaT(
    'spa.chat.finishChat.support.suggestion.label'
  );
  const othersText = useGlotaT('spa.chat.finishChat.support.other.label');

  // Opções traduzidas
  const translatedSupportOptions = useMemo(
    () =>
      SUPPORT_OPTIONS.map((opt) => {
        let label = opt.label;
        if (opt.value === 'question') label = questionText;
        else if (opt.value === 'complaint') label = complaintText;
        else if (opt.value === 'suggestion') label = suggestionText;
        else if (opt.value === 'other') label = othersText;
        return { ...opt, label };
      }),
    [questionText, complaintText, suggestionText, othersText]
  );

  return (
    <div
      className={styles.fieldContainer}
      data-testid="finish-chat-support-container"
    >
      <Controller
        name="support"
        control={control}
        render={({ field, fieldState }) => (
          <>
            <FormGroup tag="fieldset">
              {translatedSupportOptions.map((option) => (
                <FormGroup check key={option.value}>
                  <Input
                    type="radio"
                    id={option.value}
                    name="support"
                    value={option.value}
                    checked={field.value === option.value}
                    onChange={field.onChange}
                    data-testid={`finish-chat-support-option-${option.value}`}
                  />
                  <Label
                    check
                    htmlFor={option.value}
                    data-testid={`finish-chat-support-label-${option.value}`}
                  >
                    {option.label}
                  </Label>
                </FormGroup>
              ))}
              {/* Error */}
              {fieldState?.error?.message && (
                <span
                  className={styles.fieldError}
                  data-testid="finish-chat-support-error"
                >
                  {fieldState?.error?.message}
                </span>
              )}
            </FormGroup>
          </>
        )}
      />
    </div>
  );
}
